<template>
  <div class="row" v-if="isLoggedIn">
    <div class="col-10 col-md-9 col-sm-8">
      <div class="searchbox">
        <q-input
          dense
          outlined
          v-model="searchText"
          label="Zoeken op trefwoorden"
          class="search-input"
          @keydown.enter="searchGrants()"
          bg-color="white"
        >
          <!-- <template v-slot:append>
            <q-icon name="search" class="search-icon" />
          </template> -->
        </q-input>
        <a
          style="text-decoration: none"
          class="operators-help"
          href="https://www.vindsubsidies.nl/faq-database/"
          target="_blank"
        >
          Meer informatie over zoeken met operatoren
        </a>
      </div>
    </div>
    <div class="col-2 col-md-3 col-sm-4">
      <q-btn
        no-caps
        text-color="#0a1f8f"
        class="button-search"
        @click="searchGrants()"
      >
        <q-icon name="search" class="search-icon" />
        <span style="font-weight: bold">Zoeken</span>
      </q-btn>
    </div>
  </div>
</template>

<script>
import store from '../../store/index.js';
import { computed, watch } from 'vue';
import GrantsService from '../../services/grants.service';
import NewsUtils from '../../utils/news';
export default {
  setup() {
    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });

    const statusBoxes = computed({
      get: () => store.state.advancedSearch.statusesString,
    });

    const audiences = computed({
      get: () => store.state.advancedSearch.selectedAudiences,
    });
    const locations = computed({
      get: () => store.state.advancedSearch.selectedLocations,
    });
    const purposes = computed({
      get: () => store.state.advancedSearch.selectedPurposes,
    });
    const schemeTypes = computed({
      get: () => store.state.advancedSearch.selectedSchemeTypes,
    });
    const projectTypes = computed({
      get: () => store.state.advancedSearch.selectedProjectTypes,
    });
    const smeString = computed({
      get: () => store.state.advancedFilters.smeString,
    });
    const applicationTermsString = computed({
      get: () => store.state.advancedFilters.termsString,
    });

    const minBudget = computed({
      get: () => store.state.advancedSearch.minBudget,
    });

    const maxBudget = computed({
      get: () => store.state.advancedSearch.maxBudget,
    });

    const scopesString = computed({
      get: () => store.state.advancedFilters.scopesString,
    });
    const orgsIncludeString = computed({
      get: () => store.state.advancedSearch.organisationsIncludeString,
    });

    const orgsExcludeString = computed({
      get: () => store.state.advancedSearch.organisationsExcludeString,
    });

    const startDate = computed({
      get: () => store.state.advancedSearch.startDate,
    });

    const endDate = computed({
      get: () => store.state.advancedSearch.endDate,
    });

    const selectedSort = computed({
      get: () => store.state.advancedSearch.selectedSort,
    });

    //This is just hidden for now, don't remove it
    /*
    const industries = computed({
      get: () => store.state.advancedSearch.selectedIndustries,
    });
    */

    const searchGrants = async () => {
      store.commit('advancedFilters/createTermsString');
      store.commit('advancedFilters/createSMEString');
      store.commit('advancedFilters/createScopesString');
      store.commit('advancedSearch/createOrganisationsIncludeString');
      store.commit('advancedSearch/createOrganisationsExcludeString');
      await GrantsService.getSearchResults(
        searchText,
        statusBoxes,
        audiences,
        locations,
        //This is just hidden for now, don't remove it
        //industries,
        purposes,
        schemeTypes,
        projectTypes,
        smeString,
        applicationTermsString,
        minBudget,
        maxBudget,
        scopesString,
        orgsIncludeString,
        orgsExcludeString,
        startDate,
        endDate,
        selectedSort
      );

      await NewsUtils.searchNewsWithGrantsFilter();
    };

    const searchText = computed({
      get: () => store.state.advancedSearch.searchText,
      set: (val) => {
        store.commit('advancedSearch/updateSearchText', val);
        store.commit('newsSearch/updateSearchText', val);
      }
    });

    watch(
      () => searchText.value,
      async (next, prev) => {
        if (prev && prev.length > 0 && next.length == 0) {
          await GrantsService.getSearchResults(
            searchText,
            statusBoxes,
            audiences,
            locations,
            //This is just hidden for now, don't remove it
            //industries,
            purposes,
            schemeTypes,
            projectTypes,
            smeString,
            applicationTermsString,
            minBudget,
            maxBudget,
            scopesString,
            orgsIncludeString,
            orgsExcludeString,
            startDate,
            endDate,
            selectedSort
          );
        }
      }
    );

    return {
      scopesString,
      startDate,
      endDate,
      smeString,
      applicationTermsString,
      searchText,
      isLoggedIn,
      searchGrants,
      statusBoxes,
      schemeTypes,
      projectTypes,
      purposes,
      //This is just hidden for now, don't remove it
      //industries,
      audiences,
      locations,
      minBudget,
      maxBudget,
      orgsIncludeString,
      orgsExcludeString,
      selectedSort,
    };
  },
};
</script>
